import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { usePostPurchaseOrderMutation } from "../../../../store/api/purchaseorderapi";
import ActionButtonDropdown from "../../../../Components/ActionButtonDropdown"
import Pagination from "../../../../Core/Pagination/Pagination";
import ListLayout from "../../../../Core/Layout/ListLayout";
import Table from "../../../../Core/Table/Table";
import Tabs from "../../../../Components/Tabs";
import ExportCSV from '../../../../Core/Export/ExportCSV'
import ConfigureColumnsNew from "../../../../Core/ConfigureColumnsNew/ConfigureColumnsNew";
import ListFilters from "../../../../Core/ListFilters/ListFilters";
import { useDeleteDocMutation } from "../../../../store/api/globalapi";
import DelConfirmPopup from "../../../../Components/Popup/DelConfirmPopup ";
import useScreenHeight from "../../../../utils/useScreenHeight";


const MainContent = () => {
    const navigate = useNavigate();
    const { screenHeight, screenScaling , pageSize} = useScreenHeight();
    const [filters, setFilters] = useState({});
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [purchaseData, setPurchaseData] = useState({ purchase_order: [], total_no_of_records: 0 });
    const [purchaseDataApi] = usePostPurchaseOrderMutation();
    const [showColumnConfig, setShowColumnConfig] = useState(false);
    const [showExportPopup, setShowExportPopup] = useState(false);
    const [deleteDoc] = useDeleteDocMutation();
    const [delPopupVisible, setDelPopupVisible] = useState(false);
    const [delSelectedId, setDelSelectedId] = useState(null);
    const [delmessage, setDelmessage] = useState();
    const [alreadySubmitData, setAlreadySubmitData] = useState(false)
    const [delDone, setDelDone] = useState(false)

    const filtersConfig = [
        { name: 'siNo', label: 'S. No.', width: '6%', type: 'text' },
        { name: 'po_name', label: 'Purchase Order', width: '11.7%', type: 'text' },
        { name: 'company', label: 'Company', width: '10.2%', type: 'text' },
        { name: 'supplier', label: 'Vendor', width: '10%', type: 'text' },
        { name: 'no_of_lines', label: 'No. of Lines', width: '7%', type: 'number' },
        { name: 'total_qty', label: 'Total Quantity', width: '7%', type: 'number' },
        { name: 'net_total', label: 'Net Total', width: '8%', type: 'number' },
        { name: 'total', label: 'Total', width: '8%', type: 'number' },
        { name: 'grand_total', label: 'Grand Total', width: '9%', type: 'number' },
        { name: 'date_range', label: 'Order Date', width: '14%', type: 'date-range' },
        { name: 'required_by', label: 'Required By', width: '14%', type: 'date' },
        {
            name: 'status',
            label: 'Status',
            width: '9.5%',
            type: 'select',
            options: [
                { value: 'Partially Receipt', label: 'Partially Receipt' },
                { value: 'To Receive and Bill', label: 'To Receive and Bill' },
                { value: 'Draft', label: 'Draft' },
                { value: 'Completely Receipt', label: 'Completely Receipt' }
            ]
        },
        {
            name: 'wms_status',
            label: 'WMS Status',
            width: '9.5%',
            type: 'select',
            options: [
                { value: 'Partially Receipt', label: 'Partially Receipt' },
                { value: 'To Receive and Bill', label: 'To Receive and Bill' },
                { value: 'Draft', label: 'Draft' },
                { value: 'Completely Receipt', label: 'Completely Receipt' }
            ]
        }
    ];


    const handleFilterChange = (newFilters) => {
        setCurrentPage(1);
        setFilters(newFilters);
    };

    const handleView = (id) => {
        try {
            navigate(`/inbound/purchaseorder/view-purchase-order/`, { state: { PurchaseId: id } });
        } catch (err) {
            console.error("Edit failed:", err);
        }
    };

    const handleEdit = async (id) => {
        try {
            navigate(`/inbound/purchaseorder/edit-purchase-order/`, { state: { PurchaseId: id } });
        } catch (err) {
            console.error("Edit failed:", err);
        }
    };

    const handleDelete = (id) => {
        setDelSelectedId(id);
        setDelPopupVisible(true)
        setAlreadySubmitData(false)
        setDelmessage("Are you sure you want to Delete this Purchase Order")
    };

    const delHandleCancel = () => {
        setDelPopupVisible(false);
        setDelSelectedId(null);
    }

    const delHandleConfirm = async () => {
        
        try {
            await deleteDoc({ doctype: "Purchase Order", name: delSelectedId }).unwrap()
            setDelmessage(`Purchase Order ${delSelectedId} deleted successfully!`)
            setDelDone(true)
            setTimeout(() => {
                setDelPopupVisible(false);
                setDelDone(false)
                setDelSelectedId(null);
                getData();

            }, 1000);
        } catch (err) {
            console.error("Deletion Failed:", err)

            let errorMessage = "Failed to delete the Purchase Order!";

            //If the server is sending the error message , we will extract it.
            if (err?.data?._server_messages) {
                try {
                    const messageArr = JSON.parse(err.data._server_messages)
                    if (messageArr && messageArr.length > 0) {
                        //parse inner json object
                        const messageObj = JSON.parse(messageArr[0])
                        if (messageObj?.message) {
                            //extract the exact message we want
                            const fullMessage = messageObj.message
                            errorMessage = fullMessage.split('You must')[0].trim();
                            //remove html in the message
                            errorMessage = errorMessage.replace(/<[^>]+>/g, '');

                        }
                    }
                } catch (parseError) {
                    console.error("Error parsing server messages:", parseError);
                }
            }
            setDelSelectedId(null);
            setDelPopupVisible(true)
            setDelmessage(errorMessage)
            setAlreadySubmitData(true);
        } finally {
            // setTimeout(() => {
            //     setDelPopupVisible(false);
            //     setDelSelectedId(null);
            // }, 2000);
        }
    };

    const [columnsConfig, setColumnsConfig] = useState(() => [
        {
            header: "S. No.",
            name: "S. No.",
            accessor: "siNo",
            width: '7%',
            cellRenderer: (row) => row.siNo,
            sortable: false,
            visible: true
        },
        {
            header: "Purchase Order Id",
            name: "Name",
            accessor: "name",
            width: '11.7%',
            sortable: true,
            visible: true
        },
        {
            header: "Company",
            name: "Company",
            accessor: "company",
            width: '11.7%',
            sortable: true,
            visible: true
        },
        {
            header: "No. of Lines",
            name: "No. of Lines",
            accessor: "no_of_lines",
            width: '8.7%',
            sortable: true,
            visible: true,
            sortFn: (a, b) => parseInt(a.no_of_lines) - parseInt(b.no_of_lines)
        },
        {
            header: "Total Quantity",
            name: "Total Quantity",
            accessor: "total_qty",
            width: '8.7%',
            sortable: true,
            visible: true,
            sortFn: (a, b) => parseInt(a.total_qty) - parseInt(b.total_qty)
        },
        {
            header: "Vendor",
            name: "Vendor",
            accessor: "vendor",
            width: '10.7%',
            sortable: true,
            visible: true
        },
        {
            header: "WMS Status",
            name: "WMS Status",
            accessor: "wms_status",
            width: '10.7%',
            sortable: true,
            visible: true,
            cellRenderer: (row) => {
                const status = row.status;
                let color;

                switch (status) {
                    case 'Partially Receipt':
                        color = '#16A34A';
                        break;
                    case 'Draft':
                        color = '#6366F1';
                        break;
                    case 'On Hold':
                        color = '#F97316';
                        break;
                    case 'To Receive and Bill':
                        color = '#6B21A8';
                        break;
                    case 'To Receive':
                        color = '#0E7490';
                        break;
                    case 'To Bill':
                        color = '#D97706';
                        break;
                    case 'Completely Receipt':
                        color = '#65A30D';
                        break;
                    case 'Cancelled':
                        color = '#EF4444';
                        break;
                    case 'Closed':
                        color = '#E11D48';
                        break;
                    default:
                        color = '#000000';
                }

                return (
                    <span
                        style={{
                            backgroundColor: `${color}1A`,
                            color,
                            padding: '4px 10px',
                            borderRadius: '9999px',
                            fontSize: '12px',
                            fontWeight: 500,
                            display: 'inline-block',
                            textTransform: 'capitalize',
                        }}
                    >
                        {status}
                    </span>
                );
            }
        },
        {
            header: "Status",
            name: "Status",
            accessor: "status",
            width: '10.7%',
            sortable: true,
            visible: true,
            cellRenderer: (row) => {
                const status = row.status;
                let color;

                switch (status) {
                    case 'Partially Receipt':
                        color = '#16A34A';
                        break;
                    case 'Draft':
                        color = '#6366F1';
                        break;
                    case 'On Hold':
                        color = '#F97316';
                        break;
                    case 'To Receive and Bill':
                        color = '#6B21A8';
                        break;
                    case 'To Receive':
                        color = '#0E7490';
                        break;
                    case 'To Bill':
                        color = '#D97706';
                        break;
                    case 'Completely Receipt':
                        color = '#65A30D';
                        break;
                    case 'Cancelled':
                        color = '#EF4444';
                        break;
                    case 'Closed':
                        color = '#E11D48';
                        break;
                    default:
                        color = '#000000';
                }

                return (
                    <span
                        style={{
                            backgroundColor: `${color}1A`,
                            color,
                            padding: '4px 10px',
                            borderRadius: '9999px',
                            fontSize: '12px',
                            fontWeight: 500,
                            display: 'inline-block',
                            textTransform: 'capitalize',
                        }}
                    >
                        {status}
                    </span>
                );
            }
        },
        {
            header: "Date",
            name: "Date",
            accessor: "date",
            width: '10.7%',
            sortable: true,
            visible: true,
            sortFn: (a, b) => new Date(a.date) - new Date(b.date)
        },
        {
            header: "Required By",
            name: "Required By",
            accessor: "required_by",
            width: '10.7%',
            sortable: true,
            visible: true,
            sortFn: (a, b) => new Date(a.required_by) - new Date(b.required_by)
        },
        {
            header: "Net Total",
            name: "Net Total",
            accessor: "net_total",
            width: '10.7%',
            sortable: true,
            visible: true,
            sortFn: (a, b) => a.net_total - b.net_total
        },
        {
            header: "Total",
            name: "Total",
            accessor: "total",
            width: '10.7%',
            sortable: true,
            visible: false,
            sortFn: (a, b) => a.total - b.total
        },
        {
            header: "Grand Total",
            name: "Grand Total",
            accessor: "grand_total",
            width: '10.7%',
            sortable: true,
            visible: false,
            sortFn: (a, b) => a.grand_total - b.grand_total
        },
        {
            header: "Currency",
            name: "Currency",
            accessor: "currency",
            width: '8.7%',
            sortable: true,
            visible: false
        },
        {
            header: "Place of Supply",
            name: "Place of Supply",
            accessor: "place_of_supply",
            width: '10.7%',
            sortable: true,
            visible: false
        },
        {
            header: "Supplier GST",
            name: "Supplier GST",
            accessor: "supplier_gst",
            width: '10.7%',
            sortable: true,
            visible: false
        },
        {
            header: "Supplier Contact",
            name: "Supplier Contact",
            accessor: "supplier_contact",
            width: '10.7%',
            sortable: true,
            visible: false
        },
        {
            header: "Supplier Email",
            name: "Supplier Email",
            accessor: "supplier_contact_email",
            width: '12%',
            sortable: true,
            visible: false
        },
        {
            header: "Action",
            name: "Action",
            width: '10%',
            sortable: false,
            visible: true,
            accessor: 'action',
            cellRenderer: (row) => (
                <ActionButtonDropdown
                    id={row.name}
                    onView={() => handleView(row.name)}
                    onEdit={() => handleEdit(row.name)}
                    onDelete={() => handleDelete(row.name)}
                />
            )
        }
    ]);

    // Handle column configuration changes
    const handleSaveColumns = (selectedKeys, allFields) => {
        const updatedColumns = columnsConfig.map(column => {
            return {
                ...column,
                visible: selectedKeys.includes(column.accessor)
            };
        });
        setColumnsConfig(updatedColumns);
    };

    const visibleColumns = useMemo(() =>
        columnsConfig.filter(col => col.visible === true),
        [columnsConfig]
    );

    const defaultSelectedColumns = useMemo(() =>
        columnsConfig
            .filter(col => col.visible === true)
            .map(col => ({
                fieldname: col.accessor,
                label: col.name
            }))
            .filter(col => col.fieldname),
        [columnsConfig]
    );
    const activeFilterCount = useMemo(() => {
        return Object.values(filters).filter(val => val !== null && val !== undefined && val !== '').length;
    }, [filters]);
    const actionButtons = [
        {
            className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "IoFilterSharp",
            iconSize: 12,
            children: activeFilterCount > 0 ? `Filter (${activeFilterCount})` : "Filter",
            onClick: () => {
                setShowFilters(prev => !prev);
                setShowColumnConfig(false);
            }
        },
        {
            className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "MdOutlineRemoveRedEye",
            iconSize: 12,
            children: "Show more",
            onClick: () => {
                setShowColumnConfig(prev => !prev);
                setShowFilters(false);
            }


        },
        {
            className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "RiFileExcel2Fill",
            iconSize: 12,
            children: "Export Excel",
            onClick: () => setShowExportPopup(true),
        },
        {
            className: "custom-btn-00989 d-flex",
            to: "/inbound/purchaseorder/create-purchase-order",
            iconName: "FiPlus",
            style: { gap: '2px', height: '28px' },
            children: "Add Purchase Order"
        },

    ];
    const getData = async () => {
			setLoading(true);
			try {
				const filteredSearchInput = Object.entries(filters).reduce(
					(acc, [key, value]) => {
						if (value !== "" && value !== undefined && value !== null) {
							acc[key] = value;
						}
						return acc;
					},
					{}
				);
				const siNoFilter = filteredSearchInput.siNo;
				const isSiNoFilterActive =
					siNoFilter !== undefined && siNoFilter !== "";
				// STEP 3: If filtering by siNo, jump to that page
				const targetPage = isSiNoFilterActive
					? Math.ceil(parseInt(siNoFilter, 10) / pageSize)
					: currentPage;
				const payload = {
					start: pageSize * (targetPage - 1),
					limit: pageSize,
					// filters: frappeFilters,
					page_length: pageSize,
					...(Object.keys(filteredSearchInput).length > 0 && {
						search_input: filteredSearchInput,
					}),
				};

				const response = await purchaseDataApi(payload);
				const rawData = response.data.data.purchase_order;
				// STEP 4: Assign global serial numbers
				const numberedData = rawData.map((item, index) => ({
					...item,
					siNo: index + 1 + pageSize * (targetPage - 1),
				}));

				// STEP 5: If siNo is used, filter client-side
				const finalData = isSiNoFilterActive
					? numberedData.filter(
							(item) => item.siNo === parseInt(siNoFilter, 10)
					)
					: numberedData;
				setPurchaseData({
					purchase_order: finalData,
					total_no_of_records: response.data.data.total_no_of_records,
				});
				// console.log("PO Res", purchaseData);
				// Optional: update currentPage to reflect jump
				if (isSiNoFilterActive) setCurrentPage(targetPage);
			} catch (error) {
				console.error("Error fetching purchase orders:", error);
			} finally {
				setLoading(false);
			}
		};
    useEffect(() => {
        if( pageSize > 0)
            getData();
    }, [currentPage, filters, pageSize,screenHeight, screenScaling]);
    const [showFilters, setShowFilters] = useState(false);
    const accessors = [
        'name',
        'company', 
        'total_qty',
        'total',
        'grand_total',
        'currency',
        'place_of_supply',
        'status',
        'wms_status',
        'net_total',
        'supplier',
        'supplier_name',
        'transaction_date',
        'schedule_date',
        'supplier_gstin',
        'contact_person',
        'contact_email'
    ]

    return (
        <div className="container-fluid d-flex flex-column " style={{ flexGrow: '1' }}>
            <Tabs />
            <ListLayout
                breadcrumbItems={[
                    { label: "Inbound" },
                    { label: "Purchase Order List", style: { color: '#391F84' } }
                ]}
                actionButtons={actionButtons}
            >
                {showFilters && <ListFilters
                    filtersConfig={filtersConfig}
                    onFilterChange={handleFilterChange}
                    currentFilters={filters}
                    setShowFilters={setShowFilters}

                />}

                {showColumnConfig &&
                    <ConfigureColumnsNew
                        show={showColumnConfig}
                        onClose={() => setShowColumnConfig(false)}
                        onSave={handleSaveColumns}
                        docType="Purchase Order"
                        defaultSelected={defaultSelectedColumns}
                        fieldsData={columnsConfig.map(col => ({
                            fieldname: col.accessor,
                            label: col.name
                        }))}
                        disabledFields={["siNo", "status", "action", "date", "name"]}
                    />}




                <Table
                    columns={visibleColumns}
                    data={purchaseData.purchase_order}
                    loading={loading}
                />

                <Pagination
                    setCurrentPage={setCurrentPage}
                    pageSize={pageSize}
                    totalRecords={purchaseData.total_no_of_records}
                    currentPage={currentPage}
                    className="mt-2 pb-3"
                />
                {delPopupVisible &&
                    <DelConfirmPopup
                        alredysubmitdata={alreadySubmitData}
                        delSelectedId={delSelectedId}
                        visible={delPopupVisible}
                        message={delmessage}
                        onConfirm={delHandleConfirm}
                        onCancel={delHandleCancel}
                        delDone={delDone}
                    />}
                {showExportPopup && (
                    <ExportCSV
                        doctype="Purchase Order"
                        fieldsData={accessors}
                        onClose={() => setShowExportPopup(false)}
                    />
                )}
            </ListLayout>

        </div>
    );
};

export default MainContent;